import { IGetDataUser, IMessage, IPasswordEdit, IProfileEdit } from '@interfaces/index'
import api from '@services/api/server'

export default class ProfileService {
    public static async getDataUser(): Promise<IGetDataUser> {
        return (await api.get<IGetDataUser>('/users/profile')).data
    }

    public static async putDataUser(values: IProfileEdit): Promise<IMessage> {
        return (await api.put<IMessage>('/users/profile', values)).data
    }

    public static async patchPasswordUser(values: IPasswordEdit): Promise<IMessage> {
        return (await api.patch<IMessage>('/users/profile/change-password', values)).data
    }
}
